<div class="map-overlay-container ibox">
    <div class="ibox-title map-overlay-title border-primary">
        <ng-content select="app-map-overlay-header"></ng-content>
    </div>
    <div class="map-overlay-content">
        <ng-content select="app-map-overlay-content"></ng-content>
    </div>
</div>
